// extracted by mini-css-extract-plugin
export default {"header":"c98ce739472b"};